import { useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import WeatherChart from "@/components/WeatherChart";
import { useHistory } from "@/hooks/useWeather";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const RANGES = [
  { value: "24h", label: "24 ore" },
  { value: "7d", label: "7 giorni" },
  { value: "30d", label: "30 giorni" },
  { value: "12m", label: "12 mesi" },
];

const SERIES = [
  { key: "temperature", label: "Temperatura", unit: "°C", color: "#EF4444", area: true },
  { key: "humidity", label: "Umidità", unit: "%", color: "#0EA5E9", area: true },
  { key: "pressure", label: "Pressione", unit: "hPa", color: "#8B5CF6" },
  { key: "wind_speed", label: "Vento", unit: "km/h", color: "#22C55E" },
  { key: "rain_day", label: "Pioggia cumulata", unit: "mm", color: "#0EA5E9", area: true },
  { key: "solar", label: "Radiazione solare", unit: "W/m²", color: "#FBBF24", area: true },
  { key: "uv", label: "Indice UV", unit: "", color: "#F97316" },
  { key: "dew_point", label: "Punto di rugiada", unit: "°C", color: "#0B132B" },
];

export default function Grafici() {
  const [range, setRange] = useState("24h");
  const { data, isLoading } = useHistory(range);

  return (
    <div data-testid="page-grafici" className="pt-28 pb-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeader
          eyebrow="Grafici"
          title="Trend meteorologici"
          subtitle="Analizza l'andamento dei parametri della stazione su intervalli temporali diversi."
        />

        <Tabs value={range} onValueChange={setRange} className="mb-10">
          <TabsList className="rounded-full bg-white border border-slate-200 p-1 shadow-sm" data-testid="range-tabs">
            {RANGES.map((r) => (
              <TabsTrigger
                key={r.value}
                value={r.value}
                data-testid={`range-${r.value}`}
                className="rounded-full px-5 data-[state=active]:bg-[#0B132B] data-[state=active]:text-white"
              >
                {r.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>

        {isLoading && <p className="text-slate-500">Caricamento…</p>}

        <div className="grid gap-6 lg:grid-cols-2">
          {SERIES.map((s) => (
            <div key={s.key} className="metric-card p-6 md:p-8">
              <div className="flex items-baseline justify-between mb-4">
                <div>
                  <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500">{s.label}</p>
                  <h3 className="font-display text-2xl text-[#0B132B]">{s.label} · {RANGES.find(r => r.value === range)?.label}</h3>
                </div>
                <span className="text-xs text-slate-500">{data?.count ?? 0} punti</span>
              </div>
              <WeatherChart
                points={data?.points ?? []}
                dataKey={s.key}
                unit={s.unit}
                color={s.color}
                area={s.area}
                range={range}
                testId={`chart-${s.key}-${range}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
